function DownloadIcon({ className = "w-[15px] h-[15px]" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M12 3v12m0 0l4-4m-4 4l-4-4"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 21h14"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

function CtaButton({ onClick, size = "md" }) {
  const sizes =
    size === "lg"
      ? "h-14 px-7 text-[16px] gap-2.5 max-[600px]:h-11 max-[600px]:px-5 max-[600px]:text-[13px]"
      : "h-11 px-[22px] text-[14px] gap-2 max-[600px]:h-9 max-[600px]:px-3 max-[600px]:text-[12px] max-[380px]:px-2.5 max-[380px]:text-[11px]";

  return (
    <button
      type="button"
      onClick={onClick}
      className={`
        cta-download
        relative
        overflow-hidden
        rounded-[28px]
        border
        border-transparent
        text-white
        font-['Cairo']
        font-bold
        cursor-pointer
        whitespace-nowrap
        flex
        items-center
        justify-center
        shrink-0
        shadow-[0_5px_15px_rgba(223,0,24,0.18)]
        transition-[color,background,border-color,box-shadow,transform]
        duration-300
        ${sizes}
      `}
    >
      <DownloadIcon />
      <span>ابدأ طلبك</span>
    </button>
  );
}

export default CtaButton;
